import React from 'react';

import { useBreakpoint } from '@ast/magma/breakpoints';

import {
  DropDownList,
  DropDownListProps,
} from '@ast/magma/components/dropdownlist';

import { TransferType } from '@app/common/types/enum/transferType';

import { useScrollIntoView } from '@make-transfer/hooks/internal';

export type TransferTypeProps = DropDownListProps<TransferType, string>;
export type TransferTypeRef = HTMLButtonElement;

export const TransferTypeField = React.forwardRef((
  props: TransferTypeProps,
  ref: React.Ref<TransferTypeRef>,
) => {
  const isMobile = useBreakpoint().device === 'mobile';
  const { scrollRef, scrollIntoView } = useScrollIntoView<HTMLButtonElement>(true, ref);

  return (
    <DropDownList
      data-stable-name="TransferTypeDropDown"
    // Temporary hack
      {...props as DropDownListProps<any, any>}
      onOpenChange={(isOpen) => {
        if (props?.onOpenChange) {
          props.onOpenChange(isOpen);
        }
        if (isOpen && isMobile) {
          scrollIntoView();
        }
      }}
      ref={scrollRef}
    />
  );
});
